import React from "react";
import { Table } from "antd";

const { Column } = Table;

const AuthorsTable = ({ decks, onEditClick }) => {
  return (
    <Table dataSource={decks}>
      <Column title="Full Name" dataIndex="authorName" key="authorName" />
      <Column title="Email" dataIndex="authorEmail" key="authorEmail" />
      <Column
        title="Password"
        dataIndex="authorPassword"
        key="authorPassword"
      />
      <Column
        title="Action"
        key="name"
        render={(text, record) => (
          <span>
            <a
              onClick={() => onEditClick(record.id)}
              style={{ marginRight: 16 }}
            >
              Delete {record.authorName}
            </a>
          </span>
        )}
      />
    </Table>
  );
};

export default AuthorsTable;
